import React from "react";
import { useService } from "../../context/ServiceContext";
import { Prompt, Route, Switch } from "react-router-dom";
import { useIntl } from "react-intl";
import { useAccessory } from "../../context/AccessoryContext";
import SelectAccessorySeries from "../../components/AccessoryCreation/SelectAccessorySeries";
import AccessoryInformation from "../../components/AccessoryCreation/AccessoryInformation";
import AccessorySummary from "../../components/AccessoryCreation/AccessorySummary";
import NewAccessorySeries from "../../components/AccessoryCreation/NewAccessorySeries";

function AccessoryProgressSteps(props) {
  const { history } = props;
  const {} = useService();
  const { accessory, isDirty, urlPartName } = useAccessory();
  const intl = useIntl();
  const { id, series, version } = props.match.params;

  function createProgressItems() {
    let progressItems = {};
    const hasSeries = accessory.series && accessory.series.id != 0;
    const url_parts = `accessory/${id}/${series}/${version}`;

    if (id === "new") {
      progressItems.series = {
        to: "/accessories/accessory/new/-1/0/series",
        description: intl.formatMessage({ id: "product_information.select_a_series", defaultMessage: "Select a series" }),
      };
    } else if (id === "new-range") {
      progressItems.series = {
        to: "/accessories/accessory/new-range/-1/0/series",
        description: intl.formatMessage({ id: "product_information.create_a_series", defaultMessage: "Create a series" }),
      };
    }

    progressItems.technical = {
      to: `/accessories/${url_parts}/technical-information`,
      disabled: !hasSeries,
      description: intl.formatMessage({ id: "accessory_information.define_accessory_information", defaultMessage: "Define accessory information" }),
    };

    if (!accessory.isReadOnly) {
      progressItems.finish = {
        to: `/accessories/${url_parts}/finish`,
        disabled: !hasSeries,
        description: intl.formatMessage({ id: "product_information.finish", defaultMessage: "Finish" }),
      };
    }

    return progressItems;
  }

  function unsavedCheck(params) {
    return !isDirty() || accessory.isReadOnly || params.pathname.includes("/accessories/")
      ? true
      : intl.formatMessage({ id: "app.unsavedchanges", defaultMessage: "Are you sure you want to continue? You may lose any unsaved changes." });
  }

  const progressItems = createProgressItems();

  return (
    <div className="product-creation">
      <Prompt message={unsavedCheck} />

      <Switch>
        {progressItems.series && (
          <Route
            path={progressItems.series.to}
            render={(props) => {
              return id == "new-range" ? (
                <NewAccessorySeries onNext={() => history.push(progressItems.technical.to)} progressItems={progressItems} {...props} />
              ) : (
                <SelectAccessorySeries onNext={() => history.push(progressItems.technical.to)} progressItems={progressItems} {...props}></SelectAccessorySeries>
              );
            }}
          />
        )}
        <Route
          path={progressItems.technical.to}
          render={(props) => {
            return (
              <AccessoryInformation
                progressItems={progressItems}
                onNext={() => history.push(progressItems.finish.to)}
                onPrevious={progressItems.series ? () => history.push(progressItems.series.to) : undefined}
                {...props}
              ></AccessoryInformation>
            );
          }}
        />
        {!accessory.isReadOnly && (
          <Route
            path={progressItems.finish.to}
            render={(props) => {
              return <AccessorySummary progressItems={progressItems} onPrevious={() => history.push(progressItems.technical.to)} {...props}></AccessorySummary>;
            }}
          />
        )}
      </Switch>
    </div>
  );
}

export default AccessoryProgressSteps;
